// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconEllipses = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path d="M13.8 12a1.8 1.8 0 11-3.6 0 1.8 1.8 0 013.6 0m-8 0a1.8 1.8 0 11-3.6 0 1.8 1.8 0 013.6 0M20 13.8a1.8 1.8 0 100-3.6 1.8 1.8 0 000 3.6" />
  );
export default SvgIconEllipses;
